import { SegmentoType } from "src/components/projetos/types";
import api, { IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import AProvider from "src/framework/providers/AProvider";
import { ContaType, EquipeType, ExtraInfoUsuario, UsuarioConta, UsuarioProposta } from "./types";
import { TIPO_CONTA_DISTRIBUIDOR_ENGAJADO } from "src/types";

class ContaProvider extends AProvider {
    constructor() {
        super("/cadastros/contas");
    }

    async fetchDistribuidores(): Promise<ContaType[]> {
        const request: IDataRequest = { url: `${this.path}/?tipo_conta_in=1,2` }
        const response: IDataResponse = await api.get(request);
        if (response.statusCode === STATUS_CODE.OK) {
            return response.data?.rows.shit() || response.data
        }
        return [];
    }

    async getDistribuidorRevendaUsuario(): Promise<ExtraInfoUsuario | null> {

        const request: IDataRequest = { url: `${this.path}/usuario` }

        const response: IDataResponse = await api.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data?.rows || response.data
        }

        return null
    }

    async getEquipe(codigoDistribuidorRevenda: number, tipoVinculos: SegmentoType, apiInstance = api): Promise<EquipeType | null> {


        const request: IDataRequest = {
            url: `${this.path}/equipe/${codigoDistribuidorRevenda}/${tipoVinculos}`
        }

        const response: IDataResponse = await apiInstance.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            return data;
        }

        return null;
    }

    async getUsuarioConta(id: number): Promise<UsuarioConta | null> {

        const request: IDataRequest = {
            url: `${this.path}/${id}?includes=conta_uploads`
        }

        const response: IDataResponse = await api.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            return data[0];
        }

        return null;
    }

    async putUsuarioConta(id: number, data: UsuarioProposta): Promise<UsuarioConta | null> {

        const request: IDataRequest = {
            url: `${this.path}/${id}`,
            data: data,
        }

        const response: IDataResponse = await api.put(request);

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            return data[0];
        }

        return null;
    }

    async patchCodigoServico(data: { codigo_servico: string }): Promise<UsuarioConta | null> {
        const request: IDataRequest = {
            url: `${this.path}/codigo_servico`,
            data: data,
        }

        const response: IDataResponse = await api.patch(request);

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data.data || response.data;
            return data[0];
        }

        return null;
    }

    async getDistribuidorByCnpj(cnpj: string): Promise<ContaType[]> {
        const request: IDataRequest = {
            url: `${this.path}?cnpj_cpf=${cnpj}&tipo_conta_id=${TIPO_CONTA_DISTRIBUIDOR_ENGAJADO}`
        }

        const response: IDataResponse = await api.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data?.rows || response.data
        }

        return []
    }
}

export { ContaProvider }